jQuery.noConflict();

jQuery(document).ready(function(){
    jQuery(".product-container").hover(
    	function(){ $(this).addClass('hover'); }, 
		function(){ $(this).removeClass('hover'); }
    );
    
    jQuery("#sort").click(function(event){
    	event.preventDefault();
    	var url = jQuery('#collection-filter').val();
    	window.location.replace(url);
    });
    
    
    if (jQuery("#slideshow_content_container").length > 0){
    	SetupSlideShowContent();
	}
	
	jQuery("#mainNavigation li").hover(
		function(){ $("ul", this).fadeIn("fast"); }, 
		function() { } 
	);
	if (document.all) {
		jQuery("#nav-one li").hoverClass ("sfHover");
	}
	
	jQuery("#spotlight_container #email_specials_form input").blur(function(){
																				if (jQuery(this).val() == ""){
																					jQuery(this).val(jQuery(this).attr("title"));
																				}
																			});
	jQuery("#spotlight_container #email_specials_form input").focus(function(){
																			 	if (jQuery(this).val() == jQuery(this).attr("title")){
																					jQuery(this).val("");
																				}
																			 });
	
	jQuery("#spotlight_container #email_specials_form input").blur();
});

jQuery.fn.hoverClass = function(c) {
	return this.each(function(){
		$(this).hover( 
			function() { $(this).addClass(c);  },
			function() { $(this).removeClass(c); }
		);
	});
};

var slideShow_itemIndex = 0;
var slideShow_interval;
var slideShow_totalCount = 0;
function SetupSlideShowContent(){
	var slideShowItems = jQuery("#slideshow_content_container .slideshow_content_item");
	slideShow_totalCount = slideShowItems.length;
	
	var strNav = "<div class=\"slideshow_content_navigator_container\">";
	
	for (var i=0; i < slideShow_totalCount; i++){
		if (i == 0){
			jQuery(slideShowItems[i]).show();
		} else {
			jQuery(slideShowItems[i]).hide();
		}
		
		strNav += "<div class=\"slideshow_content_navigator_item";
		if (i == 0){
			strNav += " slideshow_content_navigator_itemActive";
		}
		strNav += "\"><a href=\"#\" onclick=\"showSlideItem(" + i + ");return false;\">&nbsp;</a></div>";
	}
	
	strNav += "</div>";
	jQuery("#slideshow_content_container").append(strNav);
	
	slideShow_interval = setTimeout("showSlideItem(slideShow_itemIndex + 1)", 5000);
}

function showSlideItem(moveToIndex){
	clearTimeout(slideShow_interval);
	jQuery("#slideshow_content_container .slideshow_content_navigator_item").removeClass("slideshow_content_navigator_itemActive");
	jQuery("#slideshow_content_container .slideshow_content_navigator_item:eq(" + moveToIndex + ")").addClass("slideshow_content_navigator_itemActive");
	
	var curItem = jQuery("#slideshow_content_container .slideshow_content_item:eq(" + slideShow_itemIndex + ")");
	var nextItem = jQuery("#slideshow_content_container .slideshow_content_item:eq(" + moveToIndex + ")");
	
	slideShow_itemIndex = moveToIndex;
	
	
	jQuery(curItem).fadeOut();
	jQuery(nextItem).fadeIn();
	
	if (slideShow_itemIndex > slideShow_totalCount - 2){
		slideShow_interval = setTimeout("showSlideItem(0)", 5000);
	} else {
		slideShow_interval = setTimeout("showSlideItem(slideShow_itemIndex + 1)", 5000);
	}
}